import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useLanguage } from "../../../context/LanguageContext";
import { PUBLIC_PAGE_SLUGS } from "../../../lib/queryKeys";
import {
  publicBlogPostsQueryOptions,
  publicPageQueryOptions,
} from "../../../lib/publicContentQueries";

const PublicContentPrefetcher = () => {
  const { language } = useLanguage();
  const queryClient = useQueryClient();

  useEffect(() => {
    PUBLIC_PAGE_SLUGS.forEach((slug) => {
      queryClient.prefetchQuery(publicPageQueryOptions(slug, language));
    });

    queryClient.prefetchQuery(publicBlogPostsQueryOptions(language));
    queryClient.prefetchQuery(
      publicBlogPostsQueryOptions(language, { home: true, take: 3 })
    );
  }, [language, queryClient]);

  return null;
};

export default PublicContentPrefetcher;
